async function bulkImportExcelRequest(
  url = '',
  data = {},
  apiKey,
  isReassessmentsAllowed = false,
  ignoreExistingHabitats = false,
  autoPropose = false,
  signal
) {
  const query = new URLSearchParams({
    isReassessmentsAllowed: String(isReassessmentsAllowed),
    ignoreExistingHabitats: String(ignoreExistingHabitats),
    autoPropose: String(autoPropose)
  })
  const response = await fetch(`${url}?${query.toString()}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'x-api-key': apiKey
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: data,
    signal
  })

  return response
}

export default bulkImportExcelRequest
